/**
 * Se encarga de recorrer el filtro entero y pintar las parentesis,
 * así el que lo usa solo se encarga de pasar las funciones para
 * pintar cada elemento por separado, sin bucle.
 * Es para el toString y toHumanized,... con parentesis
 *
 * NOTA: en teoria,
 * o pasamos toStringCriteria,
 * o pasamos toStringV1, toStringV2 y toStringOp, (cada uno siendo opcional)
 *
 * @param {function} toStringCriteria({v1, op, v2})
 * @param {function} toStringV1({v1, op, v2})
 * @param {function} toStringOp({v1, op, v2})
 * @param {function} toStringV2({v1, op, v2})
 * @param {function} toStringUnion(union)
 * @param {function} toStringOrderBy(orderBy)
 * @param {function} toStringGroupBy(groupBy)
 * @param {function} toStringFromTo(from, to)
 *
 *@return {string}
 */

export default function toStringFactory({
  toStringCriteria = ({ v1, op, v2 }) =>
    `${toStringV1({ v1, op, v2 })} ${toStringOp({ v1, op, v2 })} ${toStringV2({ v1, op, v2 })}`,
  toStringV1 = ({ v1, op, v2 }) => v1 || '',
  toStringOp = ({ v1, op, v2 }) => op || '',
  toStringV2 = ({ v1, op, v2 }) => v2 || '',
  toStringUnion = union => (union ? ` ${union} ` : ''),
  toStringOrderBy,
  toStringGroupBy,
  toStringFromTo,
}) {
  return filter => {
    return (
      toStringFilterCriteria(filter.filterCriteria) +
      toStringOrderBy(filter.orderBy) +
      toStringGroupBy(filter.groupBy) +
      toStringFromTo({ from: filter.from, to: filter.to })
    ).trim();
  };

  ///////////////////////////////////////////////////

  function toStringFilterCriteria(filterCriteria) {
    if (filterCriteria.criteria) {
      const { v1, op, v2 } = filterCriteria.criteria;
      return toStringCriteria({ v1, op, v2 });
    }

    if (filterCriteria.children && filterCriteria.children.length) {
      return toStringChildrens(filterCriteria.children);
    }

    return '';
  }

  function toStringChildrens(childrens) {
    let saveUnion = '';
    const res = childrens.reduce((acc, cur) => {
      const union = saveUnion;
      saveUnion = cur.union;
      if (cur.criteria) {
        const { v1, op, v2 } = cur.criteria;
        return `${acc}${acc ? toStringUnion(union) : ''}${toStringCriteria({ v1, op, v2 })}`;
      }

      if (!cur.children || !cur.children.length) {
        return acc;
      }

      return `${acc}${acc ? toStringUnion(union) : ''}(${toStringChildrens(cur.children)})`;
    }, '');

    return res;
  }

  // function toStringUnion(union){
  //   return union ? ` ${union} ` : '';
  // }
  //
  // function toStringCriteria({ v1, op, v2 }) {
  //   if (['IN', 'NOT IN'].includes(op)) {
  //     // transformamos v2 en array
  //     // v2 = (v2 || '').split(',');
  //     v2 = v2 || '';
  //     return `${v1} ${op} [${v2.split(',').join(', ')}]`;
  //   }
  //   return `${v1} ${op} ${toStringV2(v2)}`;
  //
  //   function toStringV2(v2) {
  //     let type = typeof v2;
  //     if (type === 'object' && Array.isArray(v2)) type = 'array';
  //     switch (type) {
  //       case 'string':
  //       return `"${v2}"`;
  //       // return `${v2}`;
  //       case 'number':
  //       return v2;
  //       case 'array':
  //       return `[${v2.split(',').join(', ')}]`;
  //       // return `[${v2.map(toStringV2).join(', ')}]`;
  //       default:
  //       throw new Error(`El valor del filtro tiene un tipo "${type}" desconocido`);
  //     }
  //     return v2;
  //   }
  // }
  //
  // function toStringFromTo(from, to) {
  //   if (!from && !to) return '';
  //   return ` (${from ? `from: ${from}` : ''}${from && to ? ' ' : ''}${to ? `to: ${to}` : ''})`;
  // }
  //
  // function toStringOrderBy(value) {
  //   if (!value) return '';
  //   return ' ORDER BY ' + value;
  // }
  //
  // function toStringGroupBy(value) {
  //   if (!value) return '';
  //   return ' GROUP BY ' + value;
  // }
}
